import { UtilService } from "../services/util/util.service";

export class Theme {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.name = json && json.name || null;
        this.code = json && json.code || null;
        this.primaryColorContrast = json && json.primary_color_contrast || 0;
        this.primaryColor = json && json.primary_color || 0;
        this.secondaryColorContrast = json && json.secondary_color_contrast || 0;
        this.secondaryColor = json && json.secondary_color || 0;
        this.thirdColorContrast = json && json.third_color_contrast || 0;
        this.thirdColor = json && json.third_color || 0;
        this.backgroundColorContrast = json && json.background_color_contrast || 0;
        this.backgroundColor = json && json.background_color || 0;
        this.offsetColor = json && json.offset_color || 0;
        this.isDefault = json && json.is_default || null;
        this.title = json && json.title || null;
        this.logo = json && json.logo || null;

        if(json && json.primary_color_contrast) {
            this.primaryHexColorContrast = UtilService.instance.convertLongToHexColor(json.primary_color_contrast);
        }

        if(json && json.primary_color != null) {
            this.primaryHexColor = UtilService.instance.convertLongToHexColor(json.primary_color);
        }
        
        if(json && json.secondary_color_contrast != null) {
            this.secondaryHexColorContrast = UtilService.instance.convertLongToHexColor(json.secondary_color_contrast);
        }
        
        if(json && json.secondary_color != null) {
            this.secondaryHexColor = UtilService.instance.convertLongToHexColor(json.secondary_color);
        }
        
        if(json && json.third_color_contrast != null) {
            this.thirdHexColorContrast = UtilService.instance.convertLongToHexColor(json.third_color_contrast);
        }
        
        if(json && json.third_color != null) {
            this.thirdHexColorContrast = UtilService.instance.convertLongToHexColor(json.third_color);
        }
        
        if(json && json.background_color_contrast != null) {
            this.backgroundHexColorContrast = UtilService.instance.convertLongToHexColor(json.background_color_contrast);
        }
        
        if(json && json.background_color != null) {
            this.backgroundHexColor = UtilService.instance.convertLongToHexColor(json.background_color);
        }
        
        if(json && json.offset_color != null) {
            this.offsetHexColor = UtilService.instance.convertLongToHexColor(json.offset_color);
        }
    }

    id: number;
    name: string;
    code: string;
    primaryColorContrast: number;
    primaryColor: number;
    secondaryColorContrast: number;
    secondaryColor: number;
    thirdColorContrast: number;
    thirdColor: number;
    backgroundColorContrast: number;
    backgroundColor: number;
    offsetColor: number;
    isDefault: boolean;
    title: string;
    logo: string;

    primaryHexColorContrast: string;
    primaryHexColor: string;
    secondaryHexColorContrast: string;
    secondaryHexColor: string;
    thirdHexColorContrast: string;
    thirdHexColor: string;
    backgroundHexColorContrast: string;
    backgroundHexColor: string;
    offsetHexColor: string;

    populate(theme: Theme) {
        this.id = theme.id;
        this.name = theme.name;
        this.code = theme.code;
        this.primaryColorContrast = theme.primaryColorContrast;
        this.primaryColor = theme.primaryColor;
        this.secondaryColorContrast = theme.secondaryColorContrast;
        this.secondaryColor = theme.secondaryColor;
        this.thirdColorContrast = theme.thirdColorContrast;
        this.thirdColor = theme.thirdColor;
        this.backgroundColorContrast = theme.backgroundColorContrast;
        this.backgroundColor = theme.backgroundColor;
        this.offsetColor = theme.offsetColor;
        this.isDefault = theme.isDefault;
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            code: this.code,
            primary_color_contrast: this.primaryColorContrast,
            primary_color: this.primaryColor,
            secondary_color_contrast: this.secondaryColorContrast,
            secondary_color: this.secondaryColor,
            third_color_contrast: this.thirdColorContrast,
            third_color: this.thirdColor,
            background_color_contrast: this.backgroundColorContrast,
            background_color: this.backgroundColor,
            offset_color: this.offsetColor,
            is_default: this.isDefault
        }
    }
}